<app-doc-viewer title="Theme" subtitle="Core">
  <p>Change the app theme</p>

  <app-example-viewer codeFolder="core/theme">
    <div class="actions-container">
      <mat-form-field>
        <mat-select
          (selectionChange)="loadTheme($event)"
          placeholder="Select a theme"
        >
          @for (theme of themes; track theme) {
            <mat-option [value]="theme.value">
              {{ theme.title }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </app-example-viewer>
</app-doc-viewer>
